<script>
  import { onMount } from "svelte"
  import * as utils from "../js/functions.js"

  let showFlag = false

  let angle = "-45deg"
  let distance = "60vh"

  function randomize() {
    angle = utils.getRandInt(10, 350) + "deg"
    distance = utils.getRandInt(60, 120) + "vh"
  }

  onMount(() => {
    const target = document.querySelector(".sky-container")

    setInterval(function () {
      randomize()
      target.style.setProperty("--angle", angle)
      target.style.setProperty("--distance", distance)
      showFlag = true
    }, 10000)

    setInterval(function () {
      showFlag = false
    }, 4000)

    // console.log(getComputedStyle(target).getPropertyValue("--distance"));
    // target.style.setProperty("--distance", distance);
    // console.log(getComputedStyle(target).getPropertyValue("--distance"));
    // console.log(distance);
  })
</script>

<div class="sky-container">
  {#if showFlag}
    <div class="star" />
  {/if}
</div>

<style>
  .sky-container {
    --angle: 125deg;
    --delay: 0s;
    --distance: 60vh;

    transform: rotateZ(var(--angle));
    z-index: -5;
    position: relative;
    /* background: red;
    width: 100px;
    height: 100px; */
  }

  .star {
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    background: linear-gradient(-45deg, #5f91ff, rgba(0, 0, 255, 0));
    filter: drop-shadow(0 0 6px #699bff);
    animation: tail 3000ms ease-in-out, shooting 3000ms ease-in-out;
  }

  .star::before,
  .star::after {
    position: absolute;
    content: "";
    top: calc(50% - 1px);
    right: 0;
    height: 2px;
    background: linear-gradient(
      -45deg,
      rgba(0, 0, 255, 0),
      #5f91ff,
      rgba(0, 0, 255, 0)
    );
    border-radius: 100%;
    transform: translateX(50%) rotateZ(45deg);
    animation: shining 3000ms ease-in-out;
  }

  .star::after {
    transform: translateX(50%) rotateZ(-45deg);
  }

  /* .star:nth-child(1) {
    top: calc(50% - 200px);
    left: calc(50% - 300px);
    animation-delay: var(--delay);
  }
  .star:nth-child(1)::before,
  .star:nth-child(1)::after {
    animation-delay: var(--delay);
  } */

  /* Animations */
  @keyframes tail {
    0% {
      width: 0;
    }

    30% {
      width: 100px;
    }

    100% {
      width: 0;
    }
  }

  @keyframes shining {
    0% {
      width: 0;
    }
    50% {
      width: 30px;
    }
    100% {
      width: 0;
    }
  }

  @keyframes shooting {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(var(--distance));
    }
  }
</style>
